"use client"

import { useQuery } from '@tanstack/react-query';
import { NuisibleService } from '../../../lib/api/services/nuisible.service';

const nuisibleService = new NuisibleService();

export function useNuisible(id: number | null | undefined) {
  return useQuery({
    queryKey: ['nuisible', id],
    queryFn: () => {
      if (!id) throw new Error('Nuisible ID is required');
      return nuisibleService.getNuisibleById(id);
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}